import { LookupsResourcesAPI } from 'ducks/types/api-types';
import { TReturnType } from 'ducks/types/type-helpers';
import { normalizeObjUUID } from 'ducks/utils';

export function normalizeSystemParameters<TName extends string, TId extends string>(
  array: LookupsResourcesAPI[] | string[],
  name: TName,
  id: TId,
): Array<TReturnType<TName, TId>> {
  return array.map((a, i) =>
    normalizeObjUUID({
      [id]: i,
      [name]: a,
    } as TReturnType<TName, TId>),
  );
}

export function normalizeAndSortSystemParameters(array: string[]) {
  return normalizeSystemParameters(array, 'system_parameter_name', 'system_parameter_id').sort((a, b) =>
    a.system_parameter_name && b.system_parameter_name && a.system_parameter_name > b.system_parameter_name ? 1 : -1,
  );
}
